exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".box {\r\n    position: relative;\r\n    border-top: 1px solid #fff;\r\n    border-bottom: 1px solid #fff;\r\n    background: #1268b8;\r\n}\r\n\r\n.marg {\r\n    margin-left: 0px !important;\r\n    margin-right: 0px !important;\r\n}\r\n\r\n.vertical-center {\r\n    padding-left: 310px;\r\n    padding-top: 15px;\r\n  }", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// D:/Aliva/IPCL/IPCL_SELF_CARE/src/app/components/connection-management/connection-management.component.css
// module id = ../../../../../src/app/components/connection-management/connection-management.component.css
// module chunks = 0